import { SCHEMA_VERSION, type Revision, type RevisionContent, type SongDocument } from './schema/v1'

export interface NewSongDocumentInput {
  ids: { song: string; arrangement: string; revision: string }
  /** Fecha ISO. El dominio no lee el reloj: la pasa quien llama. */
  now: string
  title: string
  artist: string
  arrangementName?: string
  author: Revision['author']
  reason?: string
  content: RevisionContent
}

/** Monta una ficha nueva: canción, arreglo «Original» y su primera revisión. */
export function createSongDocument(input: NewSongDocumentInput): SongDocument {
  const revision: Revision = {
    id: input.ids.revision,
    arrangementId: input.ids.arrangement,
    parentRevisionId: null,
    author: input.author,
    createdAt: input.now,
    content: input.content,
  }
  if (input.reason) revision.reason = input.reason
  return {
    schemaVersion: SCHEMA_VERSION,
    song: { id: input.ids.song, title: input.title, artist: input.artist, createdAt: input.now },
    arrangement: {
      id: input.ids.arrangement,
      songId: input.ids.song,
      name: input.arrangementName ?? 'Original',
      mainRevisionId: input.ids.revision,
      createdAt: input.now,
    },
    revision,
  }
}
